(function () {
  'use strict';
  if (window.FlorameComposeJobs) return;
  var KEY = 'florame_ai_compose_jobs_v1', timer = 0, running = false;
  var endpoint = 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net/createBouquetPromptProposalV1';
  function read() {
    try { var value = JSON.parse(localStorage.getItem(KEY) || '{}'); return { active: value.active || null, latest: value.latest || null, items: Array.isArray(value.items) ? value.items : [] }; }
    catch (_) { return { active: null, latest: null, items: [] }; }
  }
  function save(value) {
    value.items = value.items.filter(function (item) { return item.createdAt > Date.now() - 90 * 86400000; }).slice(0, 40);
    while (value.items.length > 1 && JSON.stringify(value).length > 1500000) value.items.pop();
    for (;;) {
      try { localStorage.setItem(KEY, JSON.stringify(value)); break; }
      catch (error) { if (!value.items.length) throw error; value.items.pop(); }
    }
  }
  function announce(job) { window.FlorameServicePause?.sync('compose',[job]); document.dispatchEvent(new CustomEvent('florame:compose-job', { detail: job })); }
  function later(delay) { clearTimeout(timer); timer = setTimeout(pump, delay); }
  function finish(job, result) {
    var store = read();
    if (store.active?.id !== job.id) return;
    var completed = { id: job.id, createdAt: job.createdAt, prompt: job.prompt, signature: job.signature,
      language: job.language, status: result.status === 'done' ? 'done' : 'error', response: result };
    store.active = null; store.latest = completed;
    if (['proposal', 'proposal_with_warning'].includes(result.outcome)) {
      store.items = [completed].concat(store.items.filter(function (item) { return item.id !== job.id; }));
    }
    save(store); announce(completed);
  }
  async function pump() {
    if (running) return;
    var job = read().active;
    if (!job) return;
    running = true;
    var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, job.accepted ? 15000 : 65000);
    try {
      // The submission is persisted before dispatch. A new page can repeat this
      // same ID safely if navigation interrupted the original acknowledgement.
      var body = job.accepted
        ? { action: 'job_status', requestId: job.id, jobAccessToken: job.token }
        : Object.assign({}, job.payload, { async: true, requestId: job.id, jobAccessToken: job.token });
      // The backend already parses JSON text. A simple POST avoids an extra
      // OPTIONS request without warming services or changing the durable job.
      var response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' }, body: JSON.stringify(body), signal: controller.signal });
      var result = await response.json();
      if (read().active?.id !== job.id) return;
      if (['done', 'error', 'cancelled', 'canceled'].includes(result.status)) { finish(job, result); return; }
      // A submission can also return an already completed result.
      if (response.ok && result.success && result.outcome) { finish(job, Object.assign({}, result, { status: 'done' })); return; }
      if (response.status === 202 && ['queued', 'running'].includes(result.status)) {
        var store = read();
        store.active.accepted = true; store.active.status = result.status; store.active.queueReason = result.queueReason || '';
        delete store.active.payload;
        save(store); announce(store.active);
        later(Math.max(2000, Math.min(15000, Number(result.retryAfterMs) || 2500)));
      } else if (response.status >= 500 || response.status === 429) later(5000);
      else finish(job, Object.assign({}, result, { status: 'error' }));
    } catch (_) {
      // Closing the page or losing connectivity never cancels the server job.
      later(5000);
    } finally { clearTimeout(timeout); running = false; }
  }
  window.FlorameComposeJobs = {
    current: function () { var store = read(); return store.active || store.latest; },
    active: function () { return read().active; },
    recent: function () { return read().items; },
    start: function (payload, metadata) {
      var store = read();
      if (store.active) { pump(); return store.active; }
      var bytes = crypto.getRandomValues(new Uint8Array(32));
      var token = Array.from(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
      var job = { id: 'compose-' + crypto.randomUUID(), token: token, createdAt: Date.now(), status: 'queued', accepted: false,
        prompt: payload.prompt, language: payload.language, signature: metadata.signature, payload: payload };
      store.active = job; save(store); announce(job); pump(); return job;
    },
    saveProposal: function (proposal, prompt) {
      if (!proposal?.response || !['proposal', 'proposal_with_warning'].includes(proposal.response.outcome)) return;
      var store = read(), id = proposal.jobId;
      if (!id) return;
      var existing = store.items.find(function (item) { return item.id === id; });
      var item = Object.assign({}, existing || { id: id, createdAt: Date.now(), status: 'done' }, { prompt: prompt, signature: proposal.signature, response: proposal.response, proposal: proposal });
      store.items = existing ? store.items.map(function (old) { return old.id === id ? item : old; }) : [item].concat(store.items);
      save(store);
    },
    resume: pump
  };
  window.addEventListener('online', pump);
  window.addEventListener('pageshow', pump);
  window.addEventListener('storage', function (event) {
    if (event.key !== KEY) return;
    var store = read(); announce(store.active || store.latest); pump();
  });
  pump();
})();
